module.exports = __webpack_public_path__ + "img/Stockroom Icon_Down.2ab59a6c.svg";